import React from 'react';
import {
  Science as ScienceIcon,
  Biotech as BiotechIcon,
  Computer as ComputerIcon,
  Psychology as PsychologyIcon,
  Public as PublicIcon,
  Language as LanguageIcon
} from '@mui/icons-material';

export const getExpertiseLevel = (level) => {
  const levels = {
    'beginner': 'Beginner',
    'intermediate': 'Intermediate',
    'advanced': 'Advanced',
    'expert': 'Expert'
  };
  return levels[level] || '';
};

export const getResearchArea = (area) => {
  const areas = {
    'genomics': 'Genomics',
    'proteomics': 'Proteomics',
    'bioinformatics': 'Bioinformatics',
    'systems_biology': 'Systems Biology',
    'epidemiology': 'Epidemiology',
    'other': 'Other'
  };
  return areas[area] || '';
};

export const getAreaIcon = (area) => {
  const icons = {
    'genomics': <ScienceIcon fontSize="small" />,
    'proteomics': <BiotechIcon fontSize="small" />,
    'bioinformatics': <ComputerIcon fontSize="small" />,
    'systems_biology': <PsychologyIcon fontSize="small" />,
    'epidemiology': <PublicIcon fontSize="small" />,
    'other': <LanguageIcon fontSize="small" />
  };
  return icons[area] || <LanguageIcon fontSize="small" />;
};

export const getExpertiseLevelColor = (level) => {
  const colors = {
    'beginner': '#4caf50',
    'intermediate': '#2196f3',
    'advanced': '#ff9800',
    'expert': '#f44336'
  };
  return colors[level] || '#757575';
};

// Signals available on the /users/ list payload (flat fields, see UserListSerializer)
const COMPLETENESS_FIELDS = [
  (u) => Boolean(u.first_name),
  (u) => Boolean(u.last_name),
  (u) => Boolean(u.avatar),
  (u) => Boolean(u.position),
  (u) => Boolean(u.location),
  (u) => Boolean(u.organization_name) || (u.affiliations?.length > 0),
  (u) => u.skills?.length > 0,
];

// Fraction (0-1) of profile fields filled in
export const calculateProfileCompleteness = (user) => {
  if (!user) return 0;
  const filled = COMPLETENESS_FIELDS.filter((check) => check(user)).length;
  return filled / COMPLETENESS_FIELDS.length;
};

// A profile counts as "complete" once most of its fields are filled in
export const COMPLETENESS_THRESHOLD = 0.8;

export const researchAreas = [
  { value: 'genomics', label: 'Genomics', icon: <ScienceIcon /> },
  { value: 'proteomics', label: 'Proteomics', icon: <BiotechIcon /> },
  { value: 'bioinformatics', label: 'Bioinformatics', icon: <ComputerIcon /> },
  { value: 'systems_biology', label: 'Systems Biology', icon: <PsychologyIcon /> },
  { value: 'epidemiology', label: 'Epidemiology', icon: <PublicIcon /> },
  { value: 'other', label: 'Other', icon: <LanguageIcon /> }
];
